import script from "./hebergementDropdownV2.vue?vue&type=script&lang=ts&setup=true"
export * from "./hebergementDropdownV2.vue?vue&type=script&lang=ts&setup=true"

import "./hebergementDropdownV2.vue?vue&type=style&index=0&id=2bef2a87&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2bef2a87"]])

export default __exports__